import { atom } from 'recoil';

export const ShowCircleMenuState = atom({
    key: 'ShowCircleMenuState', 
    default: true, 
});